export default "__VITE_ASSET__D67PE3ar__"